/**
 * ErrorBoundary — fängt Render-Fehler ab, damit ein einzelner JS-Fehler nie die
 * ganze App weiß-schießt. Zeigt eine ruhige, markenkonforme Fehlerseite mit
 * Neuladen-Option statt eines leeren Bildschirms.
 */
import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Best-effort-Telemetrie (blockiert nie). Server-Endpoint ist tolerant.
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL || ""}/api/events`;
      if (url && navigator?.sendBeacon) {
        const body = JSON.stringify({
          event: "frontend_error",
          properties: { message: String(error?.message || error).slice(0, 200) },
        });
        navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
      }
    } catch (_) { /* egal */ }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center",
                    justifyContent: "center", background: "#f5f5f4", padding: 24 }}>
        <div style={{ maxWidth: 420, background: "#fff", borderRadius: 16, padding: 28,
                      textAlign: "center", boxShadow: "0 1px 3px rgba(0,0,0,.06)",
                      fontFamily: "-apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif" }}>
          <div style={{ fontSize: 34, marginBottom: 8 }}>🦊</div>
          <h1 style={{ fontSize: 18, fontWeight: 700, color: "#1c1917", margin: "0 0 6px" }}>
            Da ist etwas schiefgelaufen
          </h1>
          <p style={{ fontSize: 14, color: "#57534e", lineHeight: 1.55, margin: "0 0 18px" }}>
            Bitte lade die Seite neu. Wenn das Problem bleibt, schreib uns kurz — wir helfen dir.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{ background: "#FF6B00", color: "#fff", border: 0, borderRadius: 10,
                     padding: "11px 20px", fontWeight: 600, fontSize: 14, cursor: "pointer" }}
          >
            Seite neu laden
          </button>
          <div style={{ marginTop: 14 }}>
            <a href="/" style={{ color: "#a8a29e", fontSize: 13, textDecoration: "none" }}>
              Zur Startseite
            </a>
          </div>
        </div>
      </div>
    );
  }
}
